import { SmileyStickerIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Sticker = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <SmileyStickerIcon color={fill} size={Sizes[size]} {...rest} />;
};

Sticker.displayName = 'Sticker';
